/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade level (FK)`)
};

const es_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de grado (FK)`)
};

const de_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassenstufe (FK)`)
};

const nl_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graad (FK)`)
};

const fr_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau scolaire (FK)`)
};

const it_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello di scuola (FK)`)
};

const pt_br2_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de série (FK)`)
};

const pt_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível escolar (FK)`)
};

const ja_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グレードレベル（FK）`)
};

const zh_ra_metric_grade = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年级水平（FK）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_metric_grade = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_metric_grade(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_metric_grade", locale)
	if (locale === "en") return en_ra_metric_grade(inputs)
	if (locale === "es") return es_ra_metric_grade(inputs)
	if (locale === "de") return de_ra_metric_grade(inputs)
	if (locale === "nl") return nl_ra_metric_grade(inputs)
	if (locale === "fr") return fr_ra_metric_grade(inputs)
	if (locale === "it") return it_ra_metric_grade(inputs)
	if (locale === "pt-BR") return pt_br2_ra_metric_grade(inputs)
	if (locale === "pt") return pt_ra_metric_grade(inputs)
	if (locale === "ja") return ja_ra_metric_grade(inputs)
	return zh_ra_metric_grade(inputs)
};